<template>
    <views>
        <nav-bar
            title="追踪溯源结果"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="trace">
            <views class="trace-title">追踪溯源结果</views>
            <views :class="{'fail': !isSuccess}" class="trace-result">{{ isSuccess ? '匹配成功' : '匹配失败'}}</views>
            <views class="trace-content">
                <views class="trace-content-list">
                    <views class="trace-content-label">明码：</views>
                    <views class="trace-content-value">{{ query.public_code }}</views>
                </views>
                <views class="trace-content-list">
                    <views class="trace-content-label">暗码：</views>
                    <views class="trace-content-value">{{ query.secret_code }}</views>
                </views>
                <views v-if="isSuccess" class="trace-content-list">
                    <views class="trace-content-label">印厂：</views>
                    <views class="trace-content-value">{{ query.printer_name }}</views>
                </views>
                <views v-if="isSuccess" class="trace-content-list">
                    <views class="trace-content-label">产品名称：</views>
                    <views class="trace-content-value">{{ query.product_name }}</views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    data() {
        return {
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        isSuccess() {
            return this.query.success === 'true'
        }
    },
    mounted() {
        this.setBgColor()
    },
    destroyed() {
        this.resetBgColor()
    },
    methods: {
        onClickLeft() {
            this.push('/person')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
